import React from 'react';
import './styles/consultation.scss';

const Consultation = ({ isOpen, onClose }) => {
  // 如果弹窗未打开，则不渲染任何内容
  if (!isOpen) return null;

  return (
    // 背景遮罩层
    <div className="consultation_overlay">
      {/* 弹窗容器 */}
      <div className="consultation_modal">
        {/* 关闭按钮 */}
        <button 
          onClick={onClose}
          className="consultation_close_btn"
          aria-label="关闭弹窗"
        >
          <img src="/img/icon_8.png" alt="关闭弹窗" className="consultation_close_img" />
        </button>
        
        {/* 弹窗内容 */}
        <div className="consultation_content">
          {/* 左侧蓝色区域 */}
          <div className="consultation_left">
            {/* 顾问头像 */}
            <div className="consultation_avatar">
            <img 
                src="/img/icon_9.png" 
                alt="专属销售顾问" 
                className="consultation_avatar_img"
            />
            </div>
            
            {/* 顾问信息 */}
            <h3 className="consultation_title">专属销售顾问</h3>
            <p className="consultation_name">云小帐</p>
            
            {/* 欢迎消息 */}
            <div className="consultation_message">
              <p className="consultation_message_text">
                您好!我是云帐天下的专业销售顾问,
                <span className="consultation_highlight">扫描右侧二维码添加微信</span>为您提供一
                对一的产品咨询和购买服务。
              </p>
            </div>
          </div>
          
          {/* 右侧白色区域 */}
          <div className="consultation_right">
            {/* 标题 */}
            <h3 className="consultation_header">微信扫码咨询购买</h3>
            <p className="consultation_service_time">服务时间: 每天8: 00~19: 00</p>
            
            {/* 二维码区域 */}
            <div className="consultation_qrcode">
              <div className="consultation_qrcode_placeholder">
                <img 
                  src="/service.png" 
                  alt="销售顾问微信二维码" 
                  className="consultation_qrcode_image"
                />
              </div>
            </div>
            
            {/* 底部说明 */}
            <p className="consultation_desc">
              添加微信后, 我们将为您提供详细的
              产品报价和专属购买方案
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Consultation;